module.exports = __webpack_public_path__ + "img/comp_3.f03dcd27.jpg";